module.exports = __webpack_public_path__ + "img/23t.5c7395b8.jpg";